/** A plugin's block on the dashboard. */
import { useTranslation } from 'react-i18next';
import type { DashboardBlock } from '@nexus/core';
import { PluginSurface } from './PluginSurface';
import { usePlugins } from './runtime';

export function PluginBlock({ block }: { block: DashboardBlock }) {
  const { t } = useTranslation();
  const plugins = usePlugins();
  if (!plugins) return null;
  const plugin = plugins.find((p) => p.pageId === block.pluginId);
  const exists = plugin?.manifest.blocks.some((b) => b.id === block.pluginBlock);
  if (!plugin || !exists || !plugin.enabled)
    return <p className="text-sm text-fg-muted">{t('plugins.blockGone')}</p>;
  return <PluginSurface plugin={plugin} kind="block" id={block.pluginBlock!} />;
}
